export default "__VITE_ASSET__BerwfiIS__"